import * as React from 'react'

function IconChecked(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={25}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 3l-9.46 10.748c-1.47 1.67-3.851 1.67-5.315 0L3 8.948"
        stroke="#FDB800"
        strokeWidth={6}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconChecked
